import { Component, Inject, Input, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIf, NgClass } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PillType } from '../../enums/knowledge-enum';
import { IsValidYearPipe } from '../../pipes/is-valid-year.pipe';
import { ChangeLanguagePipe } from '../../pipes/change-language.pipe';
import { BannerModule } from '@idb/designsystem';
import { MatDivider } from '@angular/material/divider';
import { ProjectDialogData } from '../../models/grouped-project.models';

@Component({
  selector: 'app-dialogs',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    NgIf,
    NgClass,
    TranslateModule,
    IsValidYearPipe,
    ChangeLanguagePipe,
    BannerModule,
    MatDivider,
  ],
  templateUrl: './dialogs.component.html',
  styleUrls: ['./dialogs.component.scss'],
})
export class DialogsComponent {
  @Input() dialogType!: string;
  PillType = PillType;
  hasDataPills = signal(true);

  constructor(
    public dialogRef: MatDialogRef<DialogsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Partial<ProjectDialogData>,
    private router: Router,
  ) {}

  ngOnInit() {
    if (this.data?.dialogType) {
      this.dialogType = this.data.dialogType;
    }
    if (this.dialogType === 'project_detail_dialog' && this.data?.status !== 'Execution') {
      this.hasDataPills.set(!!this.data?.hasDataPills);
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  confirmDialog(result: boolean): void {
    this.dialogRef.close(result);
  }

  navigateToLessonsSelectSet(project: ProjectDialogData) {
    if (!project.projectNumber) return;
    const returnUrl = this.router.url;
    this.closeDialog();
    void this.router.navigate([`/lessons-learning/${project.projectNumber}`], {
      state: { project, returnUrl },
    });
  }

  navigateToRemoteProjectDetail(project: ProjectDialogData): void {
    const projectNumber = project.projectNumber;
    if (!projectNumber) return;

    const returnUrl = this.router.url;
    this.closeDialog();
    setTimeout(() => {
      void this.router.navigate(
        ['/open-pill', projectNumber, projectNumber, PillType.SimilarProjects],
        {
          queryParams: {
            direct: 'true',
            returnUrl,
            ...(project.status ? { sourceStatus: project.status } : {}),
          },
          state: { directProjectFlow: true, returnUrl },
        },
      );
    }, 250);
  }

  navigateToKnowledgePills(project: ProjectDialogData, pillType: PillType) {
    if (!this.hasDataPills() && pillType == PillType.Data) return;
    this.dialogRef.close({ project, pillType });
  }

  get isDataLinkDisabled(): boolean {
    return !this.hasDataPills();
  }

  get showDataUnavailableTooltip(): boolean {
    return !this.hasDataPills();
  }
}
